import request, { getSessionJwt, setSessionJwt } from './request';
import { logWarning } from './remoteLogger';

interface ISessionJwtResponse {
  jwt?: string;
}

// Renews the session JWT, for sessions the embeddable-partner flow runs on a
// token because the browser won't send the cookie from the partner iframe.
// Sessions without a token rely on the cookie, so nothing is requested.
export const refreshSessionJwt = (): Promise<void> => {
  const currentJwt = getSessionJwt();

  if (!currentJwt) {
    return Promise.resolve();
  }

  return request<ISessionJwtResponse>('/api/user/session/user/jwt', {
    silent: true,
    persistent: true,
  })
    .then((response) => {
      // Skip a response that arrives after logout, or after the session changed.
      if (response?.jwt && getSessionJwt() === currentJwt) {
        setSessionJwt(response.jwt);
      }
    })
    .catch((error) => {
      // The next heartbeat retries while the current token is still valid.
      logWarning('SessionJwt', 'Failed to refresh the session JWT', error);
    });
};
